// extracted by mini-css-extract-plugin
module.exports = {"activeTab":"case-edit-screen_activeTab__1O8yV"};